function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable */
import React from 'react';
import { Dashboard } from '@uppy/react';
import GoldenRetriever from '@uppy/golden-retriever';
import UppyClient from './UppyClient';
import './style.scss';
import ProviderConfig from './ProviderConfig';

var UppyUploader = /*#__PURE__*/function (_React$Component) {
  _inherits(UppyUploader, _React$Component);

  var _super = _createSuper(UppyUploader);

  function UppyUploader(props) {
    var _this;

    _classCallCheck(this, UppyUploader);

    _this = _super.call(this, props);
    var providers = ProviderConfig(props);
    _this.pluginsProp = [].concat(_toConsumableArray(providers.pluginsProp), ['ImageEditor', 'LoadingStatus']);
    var sendPlugins = providers.plugins;

    if (props.recoverFiles) {
      sendPlugins = [].concat(_toConsumableArray(sendPlugins), [[GoldenRetriever, {}]]);
    }

    _this.uppy = UppyClient(props, sendPlugins);
    return _this;
  }

  _createClass(UppyUploader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // `uppy.close` or `uppy.cancelAll` should be called on unmount to allow for the
      // functioning of the onFileRemoved callback behavior. `close` or `cancelAll` methods cause
      // a `file-removed` event to be emitted by Uppy which we rely on for the onFileRemoved callback.
      this.uppy.close();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dashboard, {
        proudlyDisplayPoweredByUppy: false,
        autoOpenFileEditor: this.props.autoOpenFileEditor,
        hideCancelButton: true,
        uppy: this.uppy,
        plugins: this.pluginsProp,
        metaFields: [{
          id: 'name',
          name: 'Name',
          placeholder: 'File name'
        }]
      }));
    }
  }]);

  return UppyUploader;
}(React.Component);

var defaultFn = function defaultFn() {};

UppyUploader.defaultProps = {
  onError: defaultFn,
  onSuccess: defaultFn,
  onComplete: defaultFn,
  signature: "",
  path: "",
  bucket: "",
  storeAccess: "private",
  assetName: "Video",
  maxSize: 5368709120,
  // 5 GB
  multiple: false,
  maxFiles: 1,
  sources: [],
  extensions: null,
  debug: false,
  autoProceed: false,
  recoverFiles: false
};
export default UppyUploader;